<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="pharmacyAddressCity" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@pharmacyAddressCity">
    City
    <span class="text-danger-text">*</span>
  </label>
  <select
    formControlName="pharmacyCity"
    (change)="onChangeCity()"
    id="pharmacyAddressCity"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="pharmacyForm().get('pharmacyCity')?.invalid && pharmacyForm().get('pharmacyCity')?.touched">
    <option disabled value="" i18n="@@selectCity">Select City</option>
    @for (city of cities(); track city.id) {
      <option [value]="city.id">{{ isArabic() ? city.titleAr : isEnglish() ? city.titleEn : "" }}</option>
    }
  </select>

  @if (pharmacyForm().get("pharmacyCity")?.invalid && pharmacyForm().get("pharmacyCity")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("pharmacyCity")?.errors?.["required"]) {
        <span i18n="@@cityRequired">City is required</span>
      }
    </span>
  }
</div>
